// Common
import { Inject, Injector, Optional, Pipe, untracked, type PipeTransform, type Signal } from '@angular/core';
import { listWorkspaceScope } from '@modules/common/components/item-workspace/list-workspace-scope';
import { checkExhaustiveness } from '@modules/common/utils/switch';

// Types
import { VirtualFolder } from '../types/virtual-folder';

@Pipe({
  name: 'titleByContactsFilter',
  standalone: false,
  pure: false,
})
export class TitleByContactsFilterPipe implements PipeTransform {
  private workspaceScope?: Signal<'team' | 'mine' | undefined>;

  public constructor(@Optional() @Inject(Injector) private readonly injector: Injector | null = null) {}

  public transform(value: VirtualFolder, containerName?: string | null, nameWorkspace = false): string {
    const injector = this.injector;
    if (nameWorkspace && value === 'all_contacts' && injector) {
      this.workspaceScope ??= untracked(() => listWorkspaceScope(injector));
      const workspace = this.workspaceScope();
      if (workspace) return `${workspace === 'team' ? 'Team' : 'My'} Contacts`;
    }
    if (!value) {
      return containerName || 'All';
    }

    switch (value) {
      case 'following':
        return 'Following';
      case 'search_results':
        return 'All Results';
      case 'archived':
        return 'Archive';
      case 'deleted':
        return 'Trash';
      case 'all_contacts':
        return 'Contacts';
      case 'vip':
        return 'VIP';
      case 'flagged':
        return 'Flagged';
      case 'frequent':
        return 'Frequent';
      case 'followed':
        return 'Follow up';
      case 'all_groups':
        return 'Groups';
      case 'snoozed':
        return 'Snoozed';
      default:
        return checkExhaustiveness(value);
    }
  }
}
